module.exports = __webpack_public_path__ + "img/20190617162214QQ截图20190612162655.29adba7c.png";